<!--
 * www.cloudscope.cn
 * Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Description: 菜单列表页面
 -->
<template>
    <div class="table-list">
        <div class="header">
            <p class="title">{{title}}</p>
        </div>
        <el-table
            :data="tableData"
            class="mod-table"
            style="margin-top:19px"
            height="250"
            v-loading="loading"
        >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
                type="index"
                align="center"
                width="80"
                label="序号"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="name" align="center" label="名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="submenu.name" align="center" label="父级菜单" show-overflow-tooltip></el-table-column>
            <el-table-column prop="url" align="center" label="链接" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="图标" show-overflow-tooltip>
                <template slot-scope="scope">
                    <i>
                        <img class="menu-icon" :src="scope.row.icon" style="background:#333" />
                    </i>
                </template>
            </el-table-column>
            <el-table-column align="center" label="状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button
                        type="text"
                        prop="status"
                        @click="disableOrEnableMenu(scope.row)"
                    >{{scope.row.status== 1? "启用":"禁用"}}</el-button>
                </template>
            </el-table-column>
            <el-table-column prop="createdate" align="center" label="创建时间" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showDialog(scope.row.id)">编辑</el-button>
                    <el-button
                        type="text"
                        size="small"
                        @click="DeleteShow(scope.$index,scope.row.id)"
                    >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <footer class="main-footer">
            <!-- 底部分页 -->
            <el-pagination
                layout="total, sizes,  prev, pager, next, jumper"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                @size-change="handleSizeChange"
                @next-click="changePage"
                @prev-click="changePage"
                @current-change="changePage"
            ></el-pagination>
        </footer>
    </div>
</template>

<script>
export default {
    components: {},
    props: ['title'],
    data () {
        return {
            tableData: [],
            loading: true,
            currentPage: 1, // 当前页
            pageSize: 10, // 每页数量
            total: 0 // 总数
        };
    },
    mounted () {
        this.$nextTick(() => {
            // 创建一个查询的Bean
            let queryBean = this.buildQueryBean();
            this.loadTable(queryBean);
        });
    },
    methods: {
        /**
         * @author: liuc
         * @description: 获取分页信息： total pageSize currentPage
         * @param {data} 分页数据信息
         */
        paginationInfo (data) {
            this.total = Number(data.total);
            this.pageSize = data.pageSize;
            this.currentPage = data.pageNum;
        },
        /**
         * @author: liuc
         * @description: 获取分页菜单列表
         * @param {queryBean} 分页参数
         */
        async loadTable (queryBean) {
            // 请求数据
            let response = await this.$api.MenuManagement.getMenuList(queryBean);
            if (response.code == 200) {
                this.loading = false;
            }
            this.tableData = response.data.list;
            for (var i in this.tableData) {
                // 将时间戳转换成相应格式
                var date = this.$moment(this.tableData[i].createdate).format('yyyy-MM-dd hh:mm:ss');
                this.tableData[i].createdate = date;
            }
            this.paginationInfo(response.data);
        },
        /**
         * @author: liuc
         * @description: 新增、编辑后刷新表格
         * @param {}
         */
        async loadTableRefresh () {
            this.$emit('loadlist', this.currentPage);
        },
        /**
         * @author: liuc
         * @description: 分页组件上的：上一页/下一页/页码输入框
         * @param {cp} 当前页数
         */
        changePage: function (cp) {
            this.currentPage = cp;
            this.$emit('loadlist', cp);
        },
        /**
         * @author: liuc
         * @description: 分页组件上每页显示条数
         * @param {val} 每页显示条数
         */
        handleSizeChange (val) {
            this.$parent.pageSize = val;
            this.$emit('loadlist', this.currentPage);
        },
        /**
         * @author: liuc
         * @description: 打开编辑菜单
         * @param {id} 菜单id
         */
        showDialog (id) {
            this.$emit('showDialog', id);
        },
        /**
         * @author: liuc
         * @description: 打开删除提醒
         * @param {index} 删除数据下标
         * @param {id} 删除数据id
         */
        DeleteShow (index, id) {
            this.$confirm('确认删除？', '警告', { type: 'warning' })
                .then(async () => {
                    let response = await this.$api.MenuManagement.deleteMenuById(
                        id
                    );
                    this.$message.success(response.msg);
                    // 当删除的记录是最后一页的第一条时,删除后刷新列表到第一页
                    var lastPage =
                        this.total % this.pageSize == 0
                            ? this.total / this.pageSize
                            : Math.floor(this.total / this.pageSize) + 1;
                    if (this.currentPage == lastPage && index == 0) {
                        this.currentPage = 1;
                    }
                    this.$emit('loadlist', this.currentPage);
                })
                .catch(() => {});
        },
        /**
         * @author: liuc
         * @description: 禁用/启用菜单
         * @param {data} 菜单信息
         */
        disableOrEnableMenu (data) {
            if (data != null) {
                var message =
                    data.status == 1
                        ? '确认要禁用该菜单吗?'
                        : '确认要启用该菜单吗？';
                this.$confirm(message, '警告', { type: 'warning' })
                    .then(async () => {
                        let response = await this.$api.MenuManagement.disableOrEnableMenu(
                            data
                        );
                        this.$message.success(response.msg);
                        this.$emit('loadlist', this.currentPage);
                    })
                    .catch(() => {});
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.table-list {
    /deep/ .el-loading-mask {
        z-index: 1000;
    }
}
.header {
    .title {
        font-size: 24px;
    }
}
.el-button {
    border: 0;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    line-height: 23px;
    font-size: 12px;
    text-align: left;
    padding: 0;
    background-color: inherit;
}
</style>



// WEBPACK FOOTER //
// ./src/components/MenuManagement/List.vue